/** Nom d’en-tête : ajoutez-le sur une requête pour ne pas activer le verrouillage des boutons .btn */
export const HTTP_SKIP_BTN_LOADING_HEADER = 'X-Skip-Btn-Loading';

/**
 * Méthodes HTTP pour lesquelles les boutons `button.btn` passent en `disabled` le temps de la requête.
 * GET, HEAD, OPTIONS, etc. sont exclus.
 */
export const HTTP_BTN_LOADING_METHODS = ['POST', 'PUT', 'PATCH', 'DELETE'] as const;
